import { getApi, postApi } from '../../../utils/api'
import { getRequestWizardSessionHeader } from '../Request.utils'

import { REQUEST_WIZARD_CHUNK_PARAMS } from './RequestWizardForm.constants'

export function initWizard(data) {
  return postApi({ data, endpoint: '/api/workflow/wizard/init/' })
}

export function dryRun(workflowId) {
  return postApi({ endpoint: `/api/workflow/wizard/${workflowId}/dry-run/` })
}

export function prolong(uuid) {
  return postApi({
    endpoint: '/api/workflow/wizard/prolong/',
    headers: getRequestWizardSessionHeader(uuid),
  })
}

export function getChunk(uuid) {
  return getApi({
    endpoint: '/api/workflow/wizard/chunk/',
    headers: getRequestWizardSessionHeader(uuid),
  })
}

export function sendPayloadChunk(uuid, data) {
  return postApi({
    data,
    endpoint: '/api/workflow/wizard/chunk/',
    headers: getRequestWizardSessionHeader(uuid),
    params: REQUEST_WIZARD_CHUNK_PARAMS,
  })
}
